import React, { useCallback, useContext, useEffect, useState } from "react";

import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { IncludeLeaderboards } from "../common/components/includeLeaderboards";

export const PatientGoalEducationPreview = ({
  goal,
  goalName,
  handleGoalName,
}) => {
  const { t, DBObject, uuid } = useContext(TMDataContext);
  const [leaderboardStatus, setLeaderboardStatus] = useState(
    goal.leaderboardIncluded
  );

  const handleLeaderboardSelection = useCallback((value) => {
    setLeaderboardStatus(value.target.checked);
  }, []);

  useEffect(() => {
    goal.leaderboardIncluded = leaderboardStatus;
  }, [leaderboardStatus]);

  const educationLinkList = () => {
    return DBObject.InterviewSets.map((set) => {
      let associatedEducationLinks = goal.educationLinks.filter(
        (link) => link.parentInterview.setId == set.id
      );
      if (associatedEducationLinks.length > 0) {
        return (
          <React.Fragment key={uuid()}>
            <div className="goal-form-input-row">
              <div className="interview-link-grouping group-preview">
                <div className="goal-input-area-title full-width goal-form-underline">
                  {set.name()}
                </div>
                <div className="goal-title-input-wrap group-preview">
                  {associatedEducationLinks.map((link) => {
                    return <div key={uuid()}>{link.label}</div>;
                  })}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
    });
  };

  const displayThreshold = () => {
    if (goal.achievementTarget == 1) {
      return (
        <span className="goal-value-preview">
          {t(
            `views.goals.contexts.${goal.type.handle}.threshold_not_applicable`
          )}
        </span>
      );
    } else {
      return (
        <span className="goal-value-preview">
          {t(`views.goals.contexts.${goal.type.handle}.amber_status_start`)}{" "}
          <span className="goal-variables-preview">
            {goal.achievementThreshold}
          </span>{" "}
          {t(
            `views.goals.contexts.${goal.type.handle}.status_end_${
              goal.achievementThreshold == 1 ? "single" : "multiple"
            }`
          )}
        </span>
      );
    }
  };

  const showSchedule = () => {
    if (!goal.continuous) {
      return (
        <>
          <div className="schedule-element-preview goal-form-underline">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.start_date")}
            </div>
            <div className="interview-list-element-name">{goal.startDate}</div>
          </div>
          <div className="schedule-element-preview goal-form-underline">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.occurrences")}
            </div>
            <div className="interview-list-element-name">
              {goal.occurrenceAmount}
              {"  ("}
              {goal.occurrenceFrequency.label}
              {")"}
            </div>
          </div>
          <div className="schedule-element-preview">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.end_date")}
            </div>
            <i className="icon-ok-squared ok-squared-icon"></i>
            <div className="interview-list-element-name">{goal.endDate}</div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="schedule-element-preview goal-form-underline">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.start_date")}
            </div>
            <div className="interview-list-element-name">{goal.startDate}</div>
          </div>
          <div className="schedule-element-preview">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.occurrence")}
            </div>
            <div className="interview-list-element-name">
              {t("views.goals.contexts.occurrence_continuous")}
            </div>
          </div>
        </>
      );
    }
  };

  return (
    <>
      <div className="patient-goal-preview-row oversized-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.name")}
        </span>
        {goal.isExistingGoal() ? (
          <span className="goal-value-preview">{goal.name}</span>
        ) : (
          <span className="goal-value-preview">
            {" "}
            <div className="goal-title-input-wrap">
              <input
                type="text"
                className="goal-title-input-field"
                autoComplete="none"
                maxLength={DBObject.configVariables.goal_name_character_limit}
                onChange={handleGoalName}
                name={t("views.goals.headings.goal_name")}
                value={goalName}
                id="goal-title-input"
              />
              <span
                className="goal-title-character-count"
                style={{ float: "right" }}
              >
                {goalName.length}/
                {DBObject.configVariables.goal_name_character_limit}
              </span>
            </div>
          </span>
        )}
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.type")}
        </span>
        <span className="goal-value-preview">{goal.type.label}</span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {" "}
          {t("views.goals.headings.description")}
        </span>
        <span className="goal-value-preview" style={{ maxWidth: "400px" }}>
          {goal.description == ""
            ? t("views.goals.contexts.no_description")
            : goal.description}
        </span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.education_links")}
        </span>
        <span
          className="patient-goal-preview-list"
          style={{ marginTop: "-5px" }}
        >
          {educationLinkList()}
        </span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.achievement")}
        </span>
        <span className="goal-value-preview">
          {t(
            `views.goals.contexts.${goal.type.handle}.achievement_status_start`
          )}
          &nbsp;&nbsp;
          <span className="goal-variables-preview">
            {goal.achievementTarget}
          </span>
          &nbsp;&nbsp;
          {t(
            `views.goals.contexts.${goal.type.handle}.status_end_${
              goal.achievementTarget == 1 ? "single" : "multiple"
            }`
          )}
        </span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.amber_status")}
        </span>
        {displayThreshold()}
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.schedule")}
        </span>
        <span className="patient-goal-preview-list">{showSchedule()}</span>
      </div>
      {DBObject.configVariables.leaderboards_enabled == "true" &&
      goal.hasLeaderboardsEnabled() ? (
        <div
          className="patient-goal-preview-row"
          style={{ alignItems: "baseline" }}
        >
          <span className="patient-goal-preview-attribute-title">
            {t("views.goals.headings.leaderboard")}
          </span>
          {goal.isExistingGoal() ? (
            goal.leaderboardIncluded ? (
              t("views.goals.contexts.Leaderboard.included")
            ) : (
              t("views.goals.contexts.Leaderboard.excluded")
            )
          ) : (
            <IncludeLeaderboards
              handleLeaderboardSelection={handleLeaderboardSelection}
              leaderboardStatus={leaderboardStatus}
            />
          )}
        </div>
      ) : null}
    </>
  );
};
